var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"reset-survey"},[_c('a',{attrs:{"href":"#"}},[_c('span',{on:{"click":function($event){return _vm.reset()}}},[_vm._t("default",function(){return [_vm._v("Reset survey")]})],2)]),_vm._v(" "),_vm._t("additional-info",function(){return [_vm._v("\n    - the date will changed to today and invites resent\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }